export const TEST_ID = 'HelpLink';

export const HELP_URL = 'https://help.acreconnect.io/en/';
